import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Patients from "./components/Patients/Patient_component";
import { routes } from "./routesConfig";
import { Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { startSessionTimeout, stopSessionTimeout } from "./sessionTimeout";
import "./app.css";
import "./fonts.css";

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const hidePatientDropdown = location.pathname === "/bookappointment";

  useEffect(() => {
    const timeoutDuration = 10 * 60 * 1000; // 10 minutes

    const handleSessionTimeout = () => {
      if (
        !localStorage.getItem("authToken") ||
        !localStorage.getItem("phoneNumber") ||
        !localStorage.getItem("deviceID")
      ) {
        return;
      }

      // Remove stored session data
      localStorage.removeItem("authToken");
      localStorage.removeItem("phoneNumber");
      localStorage.removeItem("deviceID");
      localStorage.removeItem("patientList");
      localStorage.removeItem("operator");
      localStorage.removeItem("name");
      localStorage.removeItem("pushToken");
      localStorage.removeItem("selectedCard");

      // Stop any existing timeouts
      stopSessionTimeout();

      // Notify user & redirect
      alert("Your session has expired. Please sign in again.");
      navigate("/signin");
    };

    // Check if session exists before starting timeout
    if (
      localStorage.getItem("authToken") &&
      localStorage.getItem("phoneNumber") &&
      localStorage.getItem("deviceID")
    ) {
      const cleanup = startSessionTimeout(
        timeoutDuration,
        handleSessionTimeout
      );
      return () => {
        cleanup(); // Cleanup on unmount
        stopSessionTimeout(); // Ensure timer is stopped on unmount
      };
    }

    // Function to detect the device type and redirect accordingly
    // const redirectToStore = () => {
    //   const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    //   // Check if the user is using an iOS device
    //   if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    //     window.location.href = "itms-apps://apps.apple.com/pk/app/shalamar-patient-portal/id6695735854"; // Redirect to App Store
    //   }
    //   // Check if the user is using an Android device
    //   else if (/android/i.test(userAgent)) {
    //     window.location.href = "market://details?id=com.sihspatient"; // Redirect to Play Store
    //   }
    // };

    // redirectToStore(); // Call the function on component mount

  },);

  return (
    <div>
      <Navbar /> {/* Navbar component appears on all pages */}
      {!hidePatientDropdown && <Patients />}
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
      </Suspense>
    </div>
  );
};

export default App;
